var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenancy-all-projects-wrapper" }, [
    _c("div", { staticClass: "clearfix tab-header-panel" }, [
      _c("div", { staticClass: "right-btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button", role: "reset-button" },
            on: {
              click: function ($event) {
                return _vm.resetFilters()
              },
            },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("action.resetFilter")) + "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { id: "query-btn", type: "button", role: "search-button" },
            on: {
              click: function ($event) {
                return _vm.queryTenancyAllProjects()
              },
            },
          },
          [_vm._v("\n        " + _vm._s(_vm.$t("action.search")) + "\n      ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("table", { staticClass: "all-projects-table" }, [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.itemHeaders, function (header) {
              return _c(
                "th",
                {
                  key: header.name,
                  class: header.class,
                  on: {
                    click: function ($event) {
                      return _vm.sortBy(header.attrPath)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(header.name) +
                      " " +
                      _vm._s(
                        _vm.orderbyAttr === header.attrPath
                          ? _vm.reverse
                            ? "▼"
                            : "▲"
                          : null
                      ) +
                      "\n          "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", { attrs: { id: "search-panel" } }, [
              _c("th", [
                _c(
                  "div",
                  { staticClass: "date-picker" },
                  [
                    _c("DatePicker", {
                      staticClass: "columns date-range-picker",
                      attrs: {
                        calendarButton: true,
                        clearButton: true,
                        calendarButtonIcon: "fa fa-calendar",
                        placeholder: _vm.$t("dateFrom"),
                        disabled: { from: _vm.sortingAttributes.endDay },
                      },
                      model: {
                        value: _vm.sortingAttributes.startDay,
                        callback: function ($$v) {
                          _vm.$set(_vm.sortingAttributes, "startDay", $$v)
                        },
                        expression: "sortingAttributes.startDay",
                      },
                    }),
                    _vm._v(" "),
                    _c("DatePicker", {
                      staticClass: "columns date-range-picker",
                      attrs: {
                        calendarButton: true,
                        clearButton: true,
                        calendarButtonIcon: "fa fa-calendar",
                        placeholder: _vm.$t("dateTo"),
                        disabled: { to: _vm.sortingAttributes.startDay },
                      },
                      model: {
                        value: _vm.sortingAttributes.endDay,
                        callback: function ($$v) {
                          _vm.$set(_vm.sortingAttributes, "endDay", $$v)
                        },
                        expression: "sortingAttributes.endDay",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "search-filter-type" },
                [
                  _c("HKLSelect", {
                    attrs: {
                      value: _vm.projectTypeSelectValue,
                      options: _vm.typeSelectOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: { change: _vm.updateProjectTypeOption },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("th", { staticStyle: { "max-width": "40px" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sortingAttributes.project.premisesLocation,
                      expression: "sortingAttributes.project.premisesLocation",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: {
                    value: _vm.sortingAttributes.project.premisesLocation,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.sortingAttributes.project,
                        "premisesLocation",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "search-filter-type" },
                [
                  _c("HKLSelect", {
                    attrs: {
                      value: _vm.sortingAttributes.project.floor || undefined,
                      options: _vm.floorSelectOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.sortingAttributes.project.floor = val || null
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "search-filter-status" },
                [
                  _c("HKLSelect", {
                    attrs: {
                      value: _vm.sortingAttributes.project.status || undefined,
                      options: _vm.statusSelectOptions,
                      showSearch: true,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.sortingAttributes.project.status = val || null
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.sortedItems, function (item) {
              return _c("tr", { key: item.id }, [
                _c("td", [_vm._v(_vm._s(item.date || _vm.emptyValue))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("customTProjectTypeLabel")(
                        item.type || _vm.emptyValue
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_text",
                      on: {
                        click: function ($event) {
                          return _vm.navToDetail(item, true)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.showPremisesLocation(item)))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.floor || _vm.emptyValue))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("customStatusLabel")(item.status || _vm.emptyValue)
                    )
                  ),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }